import styled from "styled-components";
import Div from "app/components/Div";
import { grid } from "styled-system";

export default styled(Div).attrs(({ display }) => ({
  display: display || "grid",
}))`
  ${grid}
`;
